import { RiSearchLine } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import { Card } from "@workspace/ui/components/card";

interface SearchEmptyStateProps {
	searchTerm?: string;
	selectedGenre?: string;
	onClearSearch?: () => void;
	onClearGenre?: () => void;
}

export function SearchEmptyState({
	searchTerm,
	selectedGenre,
	onClearSearch,
	onClearGenre,
}: SearchEmptyStateProps) {
	const hasSearchTerm = searchTerm?.trim();
	const hasGenreFilter = selectedGenre && selectedGenre !== "all";

	const hasAnyFilter = hasSearchTerm || hasGenreFilter;
	const hasMultipleFilters =
		[hasSearchTerm, hasGenreFilter].filter(Boolean).length > 1;

	let message = "No artists found";

	if (hasMultipleFilters) {
		message = "Try adjusting your filters to see more artists.";
	} else if (hasSearchTerm) {
		message = `No artists match "${searchTerm}".`;
	} else if (hasGenreFilter) {
		message = `No artists found in this genre.`;
	}

	return (
		<Card className="p-8 text-center">
			<div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
				<RiSearchLine className="h-6 w-6 text-muted-foreground" />
			</div>
			<h3 className="mb-1 font-semibold text-xl">No Artists Found</h3>
			<p
				className={`text-muted-foreground text-sm ${hasAnyFilter ? "mb-4" : ""}`}
			>
				{message}
			</p>

			{hasAnyFilter && (
				<div className="flex flex-wrap justify-center gap-2">
					{hasSearchTerm && onClearSearch && (
						<Button variant="secondary" size="sm" onClick={onClearSearch}>
							Clear Search
						</Button>
					)}
					{hasGenreFilter && onClearGenre && (
						<Button variant="secondary" size="sm" onClick={onClearGenre}>
							All Genres
						</Button>
					)}
				</div>
			)}
		</Card>
	);
}
